var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[(_vm.isDy)?_c('dyTab'):_c('ksTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }